import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'fi-form-report-reminder-dialog',
    template: `
        <div class="fi-dialog-top BrandedBackgroundColor"></div>
        <h2 mat-dialog-title>{{ data.title }}</h2>

        <div mat-dialog-content>
            <p>{{ data.description }}</p>
            <!-- <div class="select-wrapper">
                        <p><b>{{"form.reminder_language_for_post" | fiAppText}}</b></p>
                        <mat-form-field appearance="outline">
                            <mat-label>{{"form.reminder_language_choose" | fiAppText}}</mat-label>
                            <mat-select [(value)]="selectedLanguageId">
                                <mat-option *ngFor="let language of languageList" [value]="language.Id">
                                    {{language.Name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->
        </div>

        <mat-dialog-actions align="end">
            <button mat-button class="BrandedColor" mat-dialog-close>
                {{ 'common.close' | fiAppText }}
            </button>
            <button mat-button class="BrandedColor" (click)="confirm()">
                {{ data.confirmButtonText }}
            </button>
        </mat-dialog-actions>
    `,
    styleUrls: ['./fi-form-report-reminder-dialog.component.scss'],
    standalone: false,
})
export class FiFormReportReminderDialogComponent implements OnInit {
    // selectedLanguageId: number;
    // languageList: IContentLanguage[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<FiFormReportReminderDialogComponent>,
        // private contentLanguageService: FiContentLanguageSharedService,
    ) {}

    ngOnInit() {
        // this.languageList = this.contentLanguageService.getContentLanguages();
        // this.selectedLanguageId = this.languageList.find(language => language.IsDefaultLanguage).Id;
    }

    confirm() {
        this.dialogRef.close(
            true,
            //{ selectedLanguageId: this.selectedLanguageId}
        );
    }
}
